export async function getBlog(id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/blogs/${id}`
    );
    const blog = await response.json();
    return blog;
  } catch (error) {
    console.log(error);
  }
}
